import React from 'react';
import Button from '@material-ui/core/Button';

const MapControlButton = ({title, text, disabled, active, onClick, children, styles, variant, color, ...props}) => {
  const useStyles = styles ?? {
    backgroundColor: color ? undefined : 'white',
    borderRadius: '4px',
    lineHeight: '14px',
    fontSize: '12px',
    padding: '9px',
    minHeight: 'auto',
    minWidth: 'auto',
    textAlign: 'center',
    whiteSpace: 'nowrap'
  }
  return (
    <Button variant={variant ?? "outlined"} style={useStyles} disabled={disabled} className={`overlayControl ${(active ? "active" : "")}`} color={color} {...props}
      title={title} onClick={onClick}>
      {text}
      {children}
    </Button>
  )
}

export default MapControlButton;